/** @format */

import React, { useContext, useMemo } from "react";
import {
  TextField,
  Grid,
  Typography,
  makeStyles,
  Box,
  Card,
  CardContent,
  CardHeader,
  Button,
  Divider,
  Modal,
  Backdrop,
  Fade,
  Tooltip,
} from "@material-ui/core";
import UserContext from "../../context/Globales/UserContext";

import PrintIcon from "@material-ui/icons/Print";
import TblDetalleEmpresa from "./TblDetalleEmpresa";
import MicroEmpresa from "@material-ui/icons/StoreMallDirectory"; // MICRO EMPRESA
import EmpresaPequena from "@material-ui/icons/HomeWork"; // EMPRESA PEQUENA

import EmpresaMediana from "@material-ui/icons/Business"; //EMPRESA MEDIANA

import EmpresaGrande from "@material-ui/icons/Apartment"; // EMPRESA GRANDE

const useStyles = makeStyles((theme) => ({
  tituloTable: {
    backgroundColor: "#e6e6e6",
    minWidth: 200,
    color: "black",
    textAlign: "center",
    padding: "16px",
    fontWeight: "250",
    fontSize: "16px",
  },
  TituloIdentificacionEmpresa: {
    backgroundColor: theme.palette.primary.main,
    minWidth: 200,
    color: "#262626",
    textAlign: "center",

    fontWeight: "250",
    fontSize: "15px",
    height: "auto",
    alignContent: "center",
  },
  fondoTituloIndicadores: {
    backgroundColor: theme.palette.fondotitulos.main,

    minWidth: 200,
    color: "#171717",
    textAlign: "center",
    padding: "15px",
    fontWeight: "300",
    fontSize: "18px",
    height: "auto",
    alignContent: "center",
  },

  FondoTable: {
    backgroundColor: theme.palette.greyFondo.main,
  },

  fondoTituloIndicadores: {
    backgroundColor: theme.palette.fondotitulos.main,
    minWidth: 200,
    color: "#171717",
    textAlign: "center",
    padding: "15px",
    fontWeight: "250",
    fontSize: "18px",
    height: "auto",
    alignContent: "center",
  },
  sizeIcono: {
    height: "50px",
    width: "50px",
  },

  fondoCardIndicadores: {
    backgroundColor: theme.palette.fondotitulos.main,
    maxWidth: "auto",
    color: "#171717",
    textAlign: "center",
    margin: "10px",
    padding: "15px",
    fontWeight: "300",
    fontSize: "14px",
    height: "145px",
    alignContent: "center",

    "&:hover": {
      backgroundColor: "#bbdefb",
      color: "#171717",
      textTransform: "uppercase",
      padding: "15px",
      fontWeight: "bold",
      height: "auto",
    },
  },

  repuestaIndicaodres: {
    color: "#171717",
    fontSize: "27px",
    align: "center",
    fontWeight: "450",
  },

  repuestaIndicarRiesgo: {
    color: "#171717",
    fontSize: "3em",
    align: "center",
    fontWeight: "500",
  },

  indicadoRiesgoNegativo: {
    color: "#BBDEFB",
    fontSize: "3em",
    align: "center",
    fontWeight: "500",
  },

  buttonVermas: {
    color: "white",

    "&:hover": {
      width: "100%",
      backgroundColor: "#1976d2",
      color: "white",
    },
  },

  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "50%",
  },
  mousePointer: { cursor: "pointer" },

  sizeIconoEmpresa: {
    height: "39px",
    width: "39px",
  },
}));

const IndicadoresEmpresas = () => {
  const classes = useStyles();

  const { datoIC } = useContext(UserContext);
  const [indicadorRiesgo, setindicadorRiesgo] = React.useState(
    JSON.parse(localStorage.getItem("score"))
  );
  const [OpenModalDetalleEmpresa, setOpenModalDetalleEmpresa] =
    React.useState(false);

  const handleClickDetalleEmpresa = () => {
    setOpenModalDetalleEmpresa(!OpenModalDetalleEmpresa);
  };

  useMemo(() => {
    const ClasificacionScore = (scor) => {
      let posicion = "";
      switch (scor) {
        case "A":
          posicion = "970";
          break;
        case "B":
          posicion = "790";
          break;
        case "C":
          posicion = "576";
          break;
        case "D":
          posicion = "456";
          break;
        case "E":
          posicion = "242";
          break;
        case "F":
          posicion = "120";
          break;
        case "G":
          posicion = "020";
          break;

        default:
          posicion = "002";
          break;
      }
      return posicion;
    };

    if (
      (datoIC && datoIC.Clasificacion !== "-" && indicadorRiesgo === null) ||
      indicadorRiesgo === undefined
    ) {
      const asigdatosScore = ClasificacionScore(datoIC && datoIC.Clasificacion);

      setindicadorRiesgo(asigdatosScore);

      // backgroundImagedatoIC && datoIC.DetalleAntecedentesCrediticios[0].Score= ClasificacionScore(datoIC && datoIC.Clasificacion)
    } else if (indicadorRiesgo !== null || indicadorRiesgo !== 0) {
      setindicadorRiesgo(indicadorRiesgo);

      //datoIC && datoIC.DetalleAntecedentesCrediticios.parseInt().Score = ress;
    } else {
      setindicadorRiesgo(0);
    }
  }, [indicadorRiesgo, datoIC]);
  return (
    <div>
      {/* Modal detalle Direcciones*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalDetalleEmpresa}
        onClose={handleClickDetalleEmpresa}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenModalDetalleEmpresa}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickDetalleEmpresa}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblDetalleEmpresa />
          </div>
        </Fade>
      </Modal>
      <CardContent>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
       {/*    <Grid item xs={6} sm={6} xl={4} md={4} lg={4}>
            <div style={{ width: "100%", display: "flex" }}>
              {" "}

              <div align="center" className={classes.repuestaIndicaodres}>

                {datoIC &&
                datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                  ?.Nombre == "GRANDE" ? (
                  <EmpresaGrande className={classes.sizeIconoEmpresa} />
                ) : datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                    ?.Nombre == "MEDIANA" ? (
                  <EmpresaMediana className={classes.sizeIconoEmpresa} />
                ) : datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                    ?.Nombre == "PEQUEÑA" ? (
                  <EmpresaPequena className={classes.sizeIconoEmpresa} />
                ) : (
                  ""
                )}{" "}
                <br />
                {datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre}
              </div>
            </div>
          </Grid> */}
       {/*    <Grid item xs={6} sm={6} xl={4} md={4} lg={4}>
            <Typography variant="body2">
              <p align="center">
                {datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                    ?.Descripcion}
              </p>
            </Typography>
          </Grid> */}

          <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
            <Tooltip title="Ver más información de la empresa">
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClickDetalleEmpresa}
                size="small"
              >
                  {datoIC &&
                datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                  ?.Nombre == "GRANDE" ? (
                  <EmpresaGrande className={classes.sizeIconoEmpresa} />
                ) : datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                    ?.Nombre == "MEDIANA" ? (
                  <EmpresaMediana className={classes.sizeIconoEmpresa} />
                ) : datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo
                    ?.Nombre == "PEQUEÑA" ? (
                  <EmpresaPequena className={classes.sizeIconoEmpresa} />
                ) : (
                  ""
                )}{" "}
                {datoIC &&
                  datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre}{" "} Ver más
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </CardContent>
    </div>
  );
};

export default IndicadoresEmpresas;
